import { getEnhancedOutcomeStatementUrl } from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class AIService {
  static getEnhancedOutcomeStatement = (
    outcomeId,
    contextId,
    contextName,
    contextCode
  ) => {
    let params = {
      outcomeId: outcomeId,
      contextId: contextId,
      contextName: contextName,
      contextCode: contextCode,
    };
    return getRequest(getEnhancedOutcomeStatementUrl(), params);
  };
}
